// Function to fetch the Netlify authentication token
export const fetchNetlifyAuthToken = async () => {
  try {
    const response = await fetch("/.netlify/functions/authenticate", {
      method: "POST",
    });

    if (!response.ok) {
      throw new Error("Failed to obtain token");
    }

    const { token } = await response.json();
    return token;
  } catch (error) {
    console.error("Error obtaining token:", error);
    throw error;
  }
};
